const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      background:
        'linear-gradient(135deg, rgba(55, 170, 237, 0.05) 0%, rgba(55, 167, 212, 0.05) 100%)',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    title: {
      fontWeight: '700',
      fontSize: '48px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '64px',
      color: '#000000',
      '@media (max-width: 768px)': {
        fontSize: '36px'
      }
    },
    cardsGrid: {
      display: 'grid',
      gap: '32px',
      marginBottom: '48px',
      '@media (min-width: 768px)': {
        gridTemplateColumns: 'repeat(3, 1fr)'
      }
    },
    uniqueCard: {
      border: '2px solid',
      borderColor: 'rgba(0,0,0,0.1)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        transform: 'translateY(-4px)'
      }
    },
    cardContent: {
      padding: '32px',
      textAlign: 'center'
    },
    cardIconContainer: {
      width: '80px',
      height: '80px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    },
    cardIcon: {
      width: '40px',
      height: '40px',
      color: '#FFFFFF'
    },
    cardTitle: {
      fontSize: '24px',
      fontWeight: '700',
      marginBottom: '16px',
      color: '#000000'
    },
    cardDescription: {
      fontSize: '18px',
      lineHeight: '1.5',
      color: 'rgba(0,0,0,0.7)'
    },
    quote: {
      fontSize: '24px',
      fontWeight: '700',
      textAlign: 'center',
      color: '#4f46e5',
      fontStyle: 'italic',
      marginTop: '32px'
    }
  };
};

export default getStyles;
